import { z } from 'zod'

export const ErrorDtoSchema = z
  .object({
    Message: z.string(),
  })
  .optional()

export type ErrorDto = z.infer<typeof ErrorDtoSchema>

export const isErrorDto = (x: unknown): x is ErrorDto => ErrorDtoSchema.safeParse(x).success
